import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalProgressSpinnerService } from '@shared/services/global-progress-spinner.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-registration-message',
  imports: [AngularSvgIconModule, ButtonModule],
  templateUrl: './registration-message.component.html',
})
export class RegistrationMessageComponent implements OnInit {
  private readonly _globalProgressSpinnerService = inject(
    GlobalProgressSpinnerService
  );

  private readonly _router = inject(Router);

  ngOnInit(): void {
    this._globalProgressSpinnerService.hideLoader();
  }

  onReturnToLoginPage(): void {
    this._router.navigate(['/login']);
  }
}
